<nz-page-header nzBackIcon [nzGhost]="false">
  <nz-page-header-title i18n>GPIO</nz-page-header-title>
  <nz-page-header-subtitle i18n>Observe and manage GPIO</nz-page-header-subtitle>
</nz-page-header>
<div nz-row>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.machineIsOn" (ngModelChange)="lineSet({
      machineIsOn: $event
    })">
      MachineIsOn (OUT)
    </label>
  </div>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.continue" (ngModelChange)="lineSet({
      continue: $event
    })">
      Continue (OUT)
    </label>
  </div>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.eject" (ngModelChange)="lineSet({
      eject: $event
    })">
      Eject (OUT)
    </label>
  </div>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.raiseAlarm" (ngModelChange)="lineSet({
      raiseAlarm: $event
    })">
      RaiseAlarm (OUT)
    </label>
  </div>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.lineIsOn" (ngModelChange)="lineSet({
      lineIsOn: $event
    })">
      LineIsOn (IN)
    </label>
  </div>
  <div nz-col nzSpan="2">
    <label i18n nz-checkbox [(ngModel)]="line.bucketIsInTheScanner" (ngModelChange)="lineSet({
      bucketIsInTheScanner: $event
    })">
      BucketIsInTheScanner (IN)
    </label>
  </div>
</div>
<div nz-row>
  @for (g of gpioState.asArray; track g) {
    <div nz-col nzSpan="2">
      <label nz-checkbox [ngModel]="g.value" (ngModelChange)="gpioSet(g.id,$event)">
        {{g.id}}
      </label>
    </div>
  }
</div>
